module.exports = __webpack_public_path__ + "static/media/kaf.d310599e.png";